/**
 * React component representing the main section for "Innovation Worth."
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for the component, including information for the "Innovation Worth" section.
 * @param {Object} props.commonAssets - Common assets shared across components.
 * @returns {JSX.Element} React component.
 */

import React, { useEffect, useState } from "react";
import InnovationWorth from "./InnovationWorth";

const InnovationWorthMain = ({ data, commonAssets, maticProduct }) => {
  return (
    <section className="bg-white mt-[80px] lg:mt-[160px]">
      <div className={`grid lg:grid-cols-12 gap-x-5 overflow-hidden`}>
        <div className={`col-span-12 flex flex-col items-center`}>
          <InnovationWorth data={data} commonAssets={commonAssets} maticProduct={maticProduct} />
        </div>
      </div>
    </section>
  );
};

export default InnovationWorthMain;
